import {
    FETCH_INVITATION_BGM,
    FETCH_INVITATION_BGMS,
} from '../actions/invitationBgm';


export const initialState = {
    isFetching: true,
    data: null
};

export const invitationBgms = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_INVITATION_BGMS}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_INVITATION_BGMS}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}

export const invitationBgm = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_INVITATION_BGM}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_INVITATION_BGM}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                data: action.payload.data,
            });
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/invitationBgm.js